/* eslint @typescript-eslint/naming-convention: 0 */
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { reject, find } from 'lodash';
import { setMainContact as setMainContactApi } from '@api/account';
import { getAdvancedUsers, getUsers } from '@api/user';
import {
  fetchUsersFailed,
  fetchUsersSucceeded,
  setList,
  setSearchTerm,
  toggleUserSucceeded,
  setMainContactSucceeded,
  setMainContactFailed,
  createUser,
  fetchUsers,
  deleteUser,
  editUser,
  toggleUser,
  setMainContact,
  selectList,
  selectSearchTerm,
  selectToggleId,
} from '@redux/ducks/users';
import { getCurrentAccount, setAccount } from '@redux/ducks/global';

// utils

export function immutableAddUser(list, user) {
  return [...list, user];
}

export function immutableEditUser(list, user) {
  const userIndex = list.findIndex(item => item.id === user.id);

  if (userIndex !== -1) {
    const nextList = list.slice();
    const item = nextList[userIndex];

    nextList.splice(userIndex, 1, {
      ...item,
      ...user,
    });
    return nextList;
  } else {
    return list;
  }
}

export function immutableDeleteUser(list, id) {
  return find(list, { id }) ? reject(list, item => item.id === id) : list;
}

// tasks

export function* putList(list) {
  yield put(setList({ list }));
}

export function* fetchUsersTask() {
  try {
    const currentAccount = yield select(getCurrentAccount);
    const accountId = currentAccount.id;

    const [list, advancedList] = yield all([call(getUsers, { accountId }), call(getAdvancedUsers, { accountId })]);
    yield put(fetchUsersSucceeded({ list, advancedList }));

    const searchTerm = yield select(selectSearchTerm);
    yield put(setSearchTerm(searchTerm));
  } catch (e) {
    yield put(fetchUsersFailed(e.message));
  }
}

export function* createUserTask({ payload }) {
  const currentList = yield select(selectList);
  const list = yield call(immutableAddUser, currentList, payload);

  yield* putList(list);
}

export function* deleteUserTask({ payload }) {
  const currentList = yield select(selectList);
  const list = yield call(immutableDeleteUser, currentList, payload);

  yield* putList(list);
}

export function* editUserTask({ payload }) {
  const currentList = yield select(selectList);
  const list = yield call(immutableEditUser, currentList, payload);

  yield* putList(list);
}

export function* toggleUserTask({ payload }) {
  const currentToggleId = yield select(selectToggleId);
  const nextToggleId = payload !== currentToggleId ? payload : null;
  yield put(toggleUserSucceeded(nextToggleId));
}

export function* setMainContactTask({ payload }) {
  const currentAccount = yield select(getCurrentAccount);
  try {
    const result = yield call(setMainContactApi, {
      id: currentAccount.id,
      main_contact_id: payload,
    });
    yield put(setAccount(result));
    yield put(setMainContactSucceeded());
  } catch (error) {
    yield put(setMainContactFailed());
  }
}

// watchers

export function* watchFetchUsers() {
  yield takeLatest(fetchUsers, fetchUsersTask);
}

export function* watchCreateUser() {
  yield takeLatest(createUser, createUserTask);
}

export function* watchDeleteUser() {
  yield takeLatest(deleteUser, deleteUserTask);
}

export function* watchEditUser() {
  yield takeLatest(editUser, editUserTask);
}

export function* watchToggleUser() {
  yield takeLatest(toggleUser, toggleUserTask);
}

export function* watchSetMainContact() {
  yield takeLatest(setMainContact, setMainContactTask);
}

// saga

export default function* usersSaga() {
  yield all([
    watchFetchUsers(),
    watchCreateUser(),
    watchDeleteUser(),
    watchEditUser(),
    watchToggleUser(),
    watchSetMainContact(),
  ]);
}
